module.exports = __webpack_public_path__ + "static/img/uber.c76dab26.png";